import { useState } from "react";

interface Props {
  className?: string;
  enableHover?: boolean;
  hoverDuration?: number;
}

export const _FooterInstagramIcon = ({
  className = "",
  enableHover = true,
  hoverDuration = 200
}: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href="https://www.instagram.com/foreveryours.films"
      target="_blank"
      rel="noopener noreferrer"
      className={`relative w-[42px] h-[42px] ${className}`}
      onMouseEnter={() => enableHover && window.innerWidth >= 768 && setIsHovered(true)}
      onMouseLeave={() => enableHover && window.innerWidth >= 768 && setIsHovered(false)}
    >
      {/* Default state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 0 : 1 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" stroke="var(--fy-grey)" strokeWidth="1" fill="none" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.2969 13.6641H17.2969C15.0878 13.6641 13.2969 15.455 13.2969 17.6641V25.6641C13.2969 27.8732 15.0878 29.6641 17.2969 29.6641H25.2969C27.506 29.6641 29.2969 27.8732 29.2969 25.6641V17.6641C29.2969 15.455 27.506 13.6641 25.2969 13.6641ZM17.2969 12.6641C14.5355 12.6641 12.2969 14.9027 12.2969 17.6641V25.6641C12.2969 28.4255 14.5355 30.6641 17.2969 30.6641H25.2969C28.0583 30.6641 30.2969 28.4255 30.2969 25.6641V17.6641C30.2969 14.9027 28.0583 12.6641 25.2969 12.6641H17.2969Z"
          fill="var(--fy-grey)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2969 24.6641C19.6401 24.6641 18.2969 23.3209 18.2969 21.6641C18.2969 20.0073 19.6401 18.6641 21.2969 18.6641C22.9538 18.6641 24.2969 20.0073 24.2969 21.6641C24.2969 23.3209 22.9538 24.6641 21.2969 24.6641ZM17.2969 21.6641C17.2969 23.8732 19.0878 25.6641 21.2969 25.6641C23.506 25.6641 25.2969 23.8732 25.2969 21.6641C25.2969 19.455 23.506 17.6641 21.2969 17.6641C19.0878 17.6641 17.2969 19.455 17.2969 21.6641Z"
          fill="var(--fy-grey)"
        />
        <circle cx="25.7969" cy="17.1641" r="1" fill="var(--fy-grey)" />
      </svg>

      {/* Hover state */}
      <svg
        className={`absolute inset-0 transition-opacity duration-${hoverDuration}`}
        style={{ opacity: isHovered && window.innerWidth >= 768 ? 1 : 0 }}
        fill="none"
        height="43"
        viewBox="0 0 43 43"
        width="43"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21.2969" cy="21.6641" r="21" fill="var(--fy-grey)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.2969 13.6641H17.2969C15.0878 13.6641 13.2969 15.455 13.2969 17.6641V25.6641C13.2969 27.8732 15.0878 29.6641 17.2969 29.6641H25.2969C27.506 29.6641 29.2969 27.8732 29.2969 25.6641V17.6641C29.2969 15.455 27.506 13.6641 25.2969 13.6641ZM17.2969 12.6641C14.5355 12.6641 12.2969 14.9027 12.2969 17.6641V25.6641C12.2969 28.4255 14.5355 30.6641 17.2969 30.6641H25.2969C28.0583 30.6641 30.2969 28.4255 30.2969 25.6641V17.6641C30.2969 14.9027 28.0583 12.6641 25.2969 12.6641H17.2969Z"
          fill="var(--fy-blue)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2969 24.6641C19.6401 24.6641 18.2969 23.3209 18.2969 21.6641C18.2969 20.0073 19.6401 18.6641 21.2969 18.6641C22.9538 18.6641 24.2969 20.0073 24.2969 21.6641C24.2969 23.3209 22.9538 24.6641 21.2969 24.6641ZM17.2969 21.6641C17.2969 23.8732 19.0878 25.6641 21.2969 25.6641C23.506 25.6641 25.2969 23.8732 25.2969 21.6641C25.2969 19.455 23.506 17.6641 21.2969 17.6641C19.0878 17.6641 17.2969 19.455 17.2969 21.6641Z"
          fill="var(--fy-blue)"
        />
        <circle cx="25.7969" cy="17.1641" r="1" fill="var(--fy-blue)" />
      </svg>
    </a>
  );
}; 